import { render, staticRenderFns } from "./ProposalCustomImage.vue?vue&type=template&id=05016c88"
import script from "./ProposalCustomImage.vue?vue&type=script&lang=js"
export * from "./ProposalCustomImage.vue?vue&type=script&lang=js"
import style0 from "./ProposalCustomImage.vue?vue&type=style&index=0&id=05016c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports